import { render } from "./Fees.vue?vue&type=template&id=4f25d130&scoped=true"
import script from "./Fees.vue?vue&type=script&lang=js"
export * from "./Fees.vue?vue&type=script&lang=js"

import "./Fees.vue?vue&type=style&index=0&id=4f25d130&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f25d130"]])

export default __exports__